import React, {useEffect, useState} from 'react'
import {Box, Button,DataTable,Text,Spinner } from 'grommet'
import { Add } from 'grommet-icons';
import { withRouter } from 'react-router-dom';
import { API,Auth } from 'aws-amplify';
import {NavigationSnackBar, TableLoadLayer} from '../../components/utils/shared/shared'
 

function AllUsers(props) {
  const [load, setLoad] = useState(true)
  const returnLab = (lab) => {
    if (lab === undefined || lab === ""){
      return <Spinner />
    } else {
      return <Text>{lab.name}</Text>
    }
  }
  const returnCustomer = (data) => {
    if (data.customer === undefined || data.customer === null){
      return <Text>{data.lab.name}</Text>
    } else {
      return <Text>{data.customer.name}</Text>
    }
  }
  const returnRole = (customer,username) => {
    if (customer === null){
      if (username === 'SAMPLELOG'){
        return <Text>SuperAdmin</Text>
      } else if (username === 'ops.eu@petro-inspect.com') { 
        return <Text>Agent</Text>
    } else {
        return <Text>Lab</Text>
      }
    } else {
      return <Text>Customer</Text>
    }
  }
    const [users, setUsers] = useState([]);
    useEffect(() => {     
      Auth.currentSession().then(session => {
        const reqUrl = (props.user === 'SuperAdmin' ? '/auth/list_users' : '/auth/lab_list_users')
        API
        .get("LabShip", reqUrl,{headers: { 
            Authorization: session.idToken.jwtToken,
          }})
        .then(
          (result) => {
           setUsers(result)
           setLoad(false)
          },
          (error) => {
            console.log(error)
          }
        )
      })
     },[]);
     if (users){
      return (
        <Box>
          <NavigationSnackBar user={props.user} pages={[{name: 'Dashboard', link: '/dashboard'},{name: 'Users'}]}  />
          <Box direction='row' justify="end">
          <Button primary label='Create User' margin="large" icon={<Add  />} hoverIndicator onClick={() => {(props.user === 'SuperAdmin' ? props.history.push('/admin/users/new') : props.history.push('/users/new'))}}/>
        </Box>
        <Box elevation="medium" round pad='small' margin='small'>
         <DataTable
            margin='small'
            background={{ header: { color: '#18445C'}, footer: { color: 'dark-3', opacity: 'strong' }}}
            columns={[
              {header:"Username",property:"username"},
              {header:"Email",property:"email",sortable:true,search:false, render: datum => (<Text>{datum.email}</Text>)},
              {header:"Role",property:"role",sortable:true,search:false,render: (datum) => returnRole(datum.customer,datum.username)},  
              {header:"Lab",property:"lab",sortable:true,search:false, render: datum => (returnLab(datum.lab))},          
              {header:"Account",property:"lab",sortable:true,search:false, render: datum => (returnCustomer(datum))},          
              ]}
             onClickRow={({datum}) => {props.history.push({pathname:`/users/edit`, state: {username: datum.username, lab: datum.lab.name}})}}
             data={users}    
             step={10}
             paginate      
           />
            <TableLoadLayer load={load} label={'Loading Users...'} />
           </Box>
       </Box>
      )
     }
    return (
      <Box>
        <NavigationSnackBar user={props.user} pages={[{name: 'Dashboard', link: '/dashboard'},{name: 'Users'}]}  />
        <Box direction='row' justify="end">
        <Button label='Create User' margin="large" icon={<Add color='brand' />} hoverIndicator onClick={() => props.history.push('/users/new')}/>
      </Box>
      <Box elevation="medium" overflow='scroll' round pad='small' margin='small' width='xlarge' alignSelf='center' justify='center'>
       
         </Box>
     </Box>
    )
}

export default withRouter(AllUsers)
